import { Box, Button } from '@mui/material';
import { useFormContext } from 'react-hook-form';

export default function FormFooter({
  onSaveDraft,
  onSubmitReview,
  onBack,
  showBack = false,
  isSubmitting = false,
  isLastStep = false,
  isPublicRoute = false
}: {
  onSaveDraft?: () => void;
  onSubmitReview?: () => void;
  onBack?: () => void;
  showBack?: boolean;
  isSubmitting?: boolean;
  mode?: 'edit' | 'public';
  isLastStep?: boolean;
  isPublicRoute?: boolean;
}) {
  const { watch } = useFormContext();

  return (
    <Box>
      <Box px={3} py={2.5} display='flex' alignItems='center' justifyContent='flex-end' gap={2}>
        {showBack && (
          <Button variant='outlined' color='secondary' sx={{ borderRadius: 20, px: 3 }} onClick={onBack}>
            Back
          </Button>
        )}

        {!isLastStep && (
          <Button
            variant='contained'
            sx={{ borderRadius: 20, px: 3 }}
            type='submit'
            onClick={onSaveDraft}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Saving...' : 'Save & Next'}
          </Button>
        )}
        {isLastStep && (
          <Button
            variant='contained'
            type='submit'
            sx={{ borderRadius: 20, px: 3 }}
            onClick={onSubmitReview}
            disabled={isSubmitting || (isLastStep && isPublicRoute && !watch('confirmation'))}
          >
            {isSubmitting ? 'Submitting...' : isPublicRoute ? 'Submit For Review' : 'Save'}
          </Button>
        )}
      </Box>
    </Box>
  );
}
